import { useSelector } from 'react-redux';
import copy from 'copy-to-clipboard';

import { useMediaPredicate } from 'react-media-hook';
import { MOBILE_SIZE } from 'utils/mediaQueryUtils';

import OutboundLink from 'components/OutboundLink';
import { prettyBorough, isManhattan } from 'utils/propertyUtils';
import Tooltip from 'components/Tooltip';

import AddToPortfolioButton from 'pages/_rd_overview/toolbar/AddToPortfolioButton';
import LinkDropdownButton from 'pages/_rd_overview/toolbar/LinkDropdownButton';
import AkaDropdownButton from 'pages/_rd_overview/toolbar/AkaDropdownButton';
import ToolbarIcons from 'pages/_rd_overview/toolbar/ToolbarIcons';

import './OverviewToolbar.css';

const OverviewToolbar = (props) => {
	const isMobile = useMediaPredicate(MOBILE_SIZE);

	let { propertyData, zoningData } = useSelector((state) => ({
		propertyData: state.property.propertyData,
		zoningData: state.zoning.data || {},
	}));

	let bin = propertyData?.bin || null;
	let block = zoningData?.block || propertyData?.block || null;
	let lot = zoningData?.lot || propertyData?.lot || null;
	let blockAndLot = null;
	if (block && lot) {
		blockAndLot = `${block}/${lot}`;
	}

	const copyBin = () => {
		copy(bin);
	};

	let binLink = null;
	if (bin) {
		binLink = (
			<span>
				<OutboundLink
					url={`http://a810-bisweb.nyc.gov/bisweb/PropertyProfileOverviewServlet?boro=${propertyData?.borough}&houseno=${propertyData?.house_number}&street=${propertyData?.street_name}`}
				>
					{bin}
				</OutboundLink>
				<Tooltip text={'Copy BIN'}>
					<button className="btn btn-link" onClick={copyBin}>
						<i className="bi bi-copy" />
					</button>
				</Tooltip>
			</span>
		);
	}

	let addressTitle = propertyData?.address;
	if (addressTitle && !isManhattan(propertyData)) {
		let borough = prettyBorough(propertyData);
		addressTitle = addressTitle?.replace('New York, NY', `${borough}, NY`);
	}

	//sometimes the 'canonical' address from the google maps api doesn't include a zip code for some reason
	//manually add the zip code to the title if it's missing
	const ZIP_REGEX = /\d{5}$/; //check if string ends in 5 digits
	if (zoningData?.zipcode && !addressTitle?.match(ZIP_REGEX)) {
		addressTitle = `${addressTitle} ${zoningData.zipcode}`;
	}

	let desktopToolbar = (
		<div className="rd-overview-toolbar">
			<div className="rd-overview-toolbar-left">
				<h1 className="rd-overview-address-title">
					{addressTitle}
				</h1>
				<div className="rd-overview-address-subtitle">
					{blockAndLot && (
						<span className="block-lot-bin-header">
							[Block/Lot - {blockAndLot}]
						</span>
					)}
					{binLink && (
						<span className="block-lot-bin-header">[BIN - {binLink}]</span>
					)}
				</div>
				{propertyData?.id && (
					<div className="rd-overview-aka-wrapper">
						<AkaDropdownButton />
					</div>
				)}
			</div>

			<div className="rd-overview-toolbar-right">
				<div className="rd-overview-actions-row">
					<LinkDropdownButton listName="propertyDocuments" property={propertyData} />
					<LinkDropdownButton listName="quickLinks" property={propertyData} />
					<LinkDropdownButton listName="codes" property={propertyData} />
					<AddToPortfolioButton />
				</div>
				<div className="rd-overview-icons-row">
					<ToolbarIcons />
				</div>
			</div>
		</div>
	);

	let mobileToolbar = (
		<div className="rd-overview-toolbar mobile">
			<div className="rd-overview-toolbar-left">
				<h1 className="rd-overview-address-title">
					{addressTitle}
				</h1>
				<div className="rd-overview-address-subtitle">
					{blockAndLot && (
						<span className="block-lot-bin-header">
							[Block/Lot - {blockAndLot}]
						</span>
					)}
					{binLink && (
						<span className="block-lot-bin-header">[BIN - {binLink}]</span>
					)}
				</div>
				{propertyData?.id && (
					<div className="rd-overview-aka-wrapper">
						<AkaDropdownButton />
					</div>
				)}
			</div>
			<div className="rd-overview-toolbar-mobile-buttons mt-2">
				<div className="d-flex align-items-center gap-1 flex-wrap">
					<LinkDropdownButton
						listName="propertyDocuments"
						property={propertyData}
						iconOnly
					/>
					<LinkDropdownButton
						listName="quickLinks"
						property={propertyData}
						iconOnly
					/>
					<LinkDropdownButton
						listName="codes"
						property={propertyData}
						iconOnly
					/>
					<AddToPortfolioButton />
				</div>
				<div className="mt-2">
					<ToolbarIcons />
				</div>
			</div>
		</div>
	);

	if (isMobile) {
		return mobileToolbar;
	}
	return desktopToolbar;
};

export default OverviewToolbar;
